var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awsui-util-container"},[_c('div',{staticClass:"awsui-util-container-header"},[_c('h2',[_vm._v("Not Allowed to view this page")])])])
}]

export { render, staticRenderFns }